"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _UpdateRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/UpdateRound"));

// Generated by script, don't edit it please.
var UpdateRound = (0, _createSvgIcon["default"])({
  as: _UpdateRound["default"],
  ariaLabel: 'update round',
  category: 'status',
  displayName: 'UpdateRound'
});
var _default = UpdateRound;
exports["default"] = _default;
module.exports = exports.default;